<template>
  <section
    class="h-screen w-full bg-image pr-10 pl-10 lg:px-140px 3xl:px-200px 4xl:px-300px"
    :style="{ '--home-bg': 'url(' + homeBgURL + ')' }"
  >
    <div
      class="text-white h-2 text-12px md:text-xl w-auto pt-24 md:pt-48 lg:pt-48  xl:pt-48 3.5xl:pt-56 4xl:pt-100 tracking-1.8px leading-60px"
    >
      <div>{{ $t('main_screen.small_header') }}</div>
    </div>
    <div class="home-page-grid">
      <div
        class="title-parent flex-auto text-white  text-50px 3xl:text-80px md:font-bold pt-16 font-Foco leading-60px lg:w-1/3 2xl:w-1/2 3.5xl:w-1/3"
      >
        <div class="whitespace-pre-line">
          <div
            class="leading-title"
            v-for="(line, idx) in $t('main_screen.big_header').split('\n')"
            :key="idx"
            :data-lang="locale"
          >
            {{ line }}
          </div>
        </div>
      </div>
      <div
        class="download-parent flex mt-8 sm:mt-16 lg:order-last justify-between md:justify-start 3xl:justify-start"
        v-if="shouldShowAppStoreLinks()"
      >
        <a
          class="w-130px md:h-16 lg:h-24 lg:w-1/3 3xl:w-1/3"
          :href="appStoreLinks.ios"
        >
          <img class="inline" :src="appleStoreLink" />
        </a>
        <a
          class="w-130px md:h-16 lg:h-24 lg:w-1/3 3xl:w-1/3 lg:ml-10 3xl:ml-20 md:ml-12"
          :href="appStoreLinks.android"
        >
          <img class="inline" :src="googleStoreLink" />
        </a>
      </div>
      <div
        v-if="shouldShowPopup"
        id="btn-popup"
        class="cta-parent justify-center flex-auto self-end text-center cursor-pointer"
        v-on:click="isModalVisible = true"
      >
        <div v-if="matchEntities(['NETHERLANDS'])" class="ExternalFormCTA">
          <div
            class="md:text-20px PilotText px-8 py-3 text-sm tracking-0.24px md:tracking-0.4px font-bold text-right md:mt-2"
          >
            {{ $t('main_screen.pilot_btn_top') }}
          </div>
        </div>
        <div
          v-else
          class="w-full PilotBody rounded-58px rounded-full border-solid border border-qwellow mt-16 md:mt-64 lg:mt-0 p-1 shadow-md btn-gradient inline-flex"
        >
          <div class="flex-row w-4/5 pt-2 text-white">
            <div
              class="md:text-20px PilotText text-sm tracking-0.24px md:tracking-0.4px font-bold text-right md:mt-2"
            >
              {{ $t('main_screen.pilot_btn_top') }}
            </div>
          </div>
          <div class="flex w-1/5 justify-end">
            <img
              src="~@/assets/arrow.svg"
              class=" self-center mr-8 h-6 md:h-8"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="isModalVisible">
      <PopupDE v-if="entity === 'GERMANY'" v-on:modalClose="onModalClose" />
      <PopupNL v-if="entity === 'NETHERLANDS'" v-on:modalClose="onModalClose" />
      <popup-stations-desktop v-else v-on:modalClose="onModalClose" />
    </div>
  </section>
</template>

<script>
import hasPopupQuery from '@/shared/homePagePopupChecker';
import PopupStationsDesktop from './PopupStationsDesktop.vue';
import PopupDE from './PopupDE.vue';
import PopupNL from './PopupNL.vue';
import { entity } from '../../../../region.json';
import appStoreLinks from '../../../data/appStoreLinks';
import matchEntities, {
  NETHERLANDS,
  allowPopup,
  shouldShowAppStoreLinks,
  shouldShowExternalFormCTA,
} from '../../../shared/entityHelpers';

export default {
  components: { PopupStationsDesktop, PopupDE, PopupNL },
  data() {
    return {
      isModalVisible: false,
      appStoreLinks,
      NETHERLANDS,
      entity,
      locale: this.$i18n.locale,
      homeBgURL: this.matchEntities(['POLAND', 'NETHERLANDS'])
        ? // eslint-disable-next-line global-require
          require('@/assets/home-bg-POLAND.jpg')
        : // eslint-disable-next-line global-require
          require('@/assets/home-bg.jpg'),
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onModalClose() {
      this.closeModal();
    },
    matchEntities,
    shouldShowAppStoreLinks,
    shouldShowExternalFormCTA,
  },
  computed: {
    isMobile() {
      // eslint-disable-next-line
      return screen.width <= 834;
    },
    appleStoreLink() {
      if (this.entity === 'POLAND' && this.locale === 'pl') {
        // eslint-disable-next-line
        return require(`@/assets/apple-app-store-btn-${this.entity}-${this.locale}.svg`);
      }
      // eslint-disable-next-line
      return require(`@/assets/apple-app-store-btn-EN.svg`);
    },
    googleStoreLink() {
      if (this.entity === 'POLAND' && this.locale === 'pl') {
        // eslint-disable-next-line
        return require(`@/assets/google-play-store-btn-${this.entity}-${this.locale}.svg`);
      }
      // eslint-disable-next-line
      return require(`@/assets/google-play-store-btn-EN.svg`);
    },
    shouldShowPopup() {
      return allowPopup();
    },
  },
  mounted() {
    if (
      (this.shouldShowPopup && hasPopupQuery(this.$router)) ||
      matchEntities(['NETHERLANDS'])
    ) {
      this.isModalVisible = true;
    }
  },
};
</script>

<style scoped>
.ExternalFormCTA {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--qwellow);
  color: var(--qwray);
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #ffdf22;
  float: right;
}
.ExternalFormCTA[margin] {
  margin-bottom: 4em;
}
@media (min-width: 768px) {
  .ExternalFormCTA {
    font: normal normal bold 24px/28px Lato;
    letter-spacing: 0.48px;
    border-radius: 40px;
    /* padding: 1em 1.8em; */
    width: max-content;
  }
  .ExternalFormCTA[margin] {
    margin-bottom: unset;
  }
}

.bg-image {
  background: var(--home-bg) center center no-repeat;
  background-size: cover;
}
.btn-gradient {
  background-image: linear-gradient(
    rgba(255, 223, 34, 0.3),
    rgba(255, 223, 34, 0.3)
  );
}

.leading-title {
  line-height: 1.5;
  width: max-content;
}
@media (max-width: 768px) {
  .PilotBody {
    max-width: 350px;
  }
}

.title-parent {
  grid-area: title;
  width: max-content;
}
.cta-parent {
  grid-area: cta;
  align-self: flex-end;
  width: max-content;
}
.download-parent {
  grid-area: download;
}
.home-page-grid {
  display: grid;
  grid-template-columns: 1fr 20% 1fr;
  grid-template-areas:
    'title empty cta'
    'download empty nothing';
}
.PilotText {
  font-size: 16px;
  margin-top: 0;
}

@media (min-width: 800px) {
  .cta-parent {
    width: 300px !important;
    height: auto !important;
  }
  .PilotText {
    font-size: 16px;
  }
}
@media (min-width: 1200px) {
  .cta-parent {
    width: 430px !important;
    height: 95px !important;
  }

  .PilotText {
    font-size: 20px;
  }
}
@media (min-width: 1400px) {
  .PilotText {
    font-size: 24px;
  }
}

/* 

  Special case for French translation of the leading-title.

  For other langauges the sentence is split into new lines,
  but the phrase doesn't work well in French and the text overflowing its window. 

  So instead, this fix/hack just ensures that the title doesn't expand more than 15 characters. 

*/

@media (min-width: 768px) {
  .leading-title[data-lang='fr'] {
    max-width: 15ch;
  }
}
</style>
